import { makeObservable, observable } from 'mobx';

import FiltroAnotacoes from '@/components/filtros/FiltroAnotacoes';
import FiltroAnotacoesComplementares from '@/components/filtros/FiltroAnotacoesComplementares';
import FiltroAnotacoesCurtas from '@/components/filtros/FiltroAnotacoesCurtas';
import FiltroCienciaDomicilioEletronico from './filtros/FiltroCienciaDomicilioEletronico';
import FiltroClasseJudicial from './filtros/FiltroClasseJudicial';
import FiltroClasseJudicialCompleta from './filtros/FiltroClasseJudicialCompleta';
import FiltroCorreJunto from './filtros/FiltroCorreJunto';
import FiltroDataPublicacaoPauta from './filtros/FiltroDataPublicacaoPauta';
import FiltroDomicilioEletronico from './filtros/FiltroDomicilioEletronico';
import FiltroImpedimentos from './filtros/FiltroImpedimentos';
import FiltroImpedimentosMagistrado from './filtros/FiltroImpedimentosMagistrado';
import FiltroIncluidoPeloGabinete from './filtros/FiltroIncluidoPeloGabinete';
import FiltroInclusaoConfirmadaPauta from './filtros/FiltroInclusaoConfirmadaPauta';
import FiltroIndicadores from './filtros/FiltroIndicadores';
import FiltroInformacaoIntimacao from './filtros/FiltroInformacaoIntimacao';
import FiltroIntimacaoDomicilioEletronico from './filtros/FiltroIntimacaoDomicilioEletronico';
import FiltroIntimacaoViaMalote from './filtros/FiltroIntimacaoViaMalote';
import FiltroMesmaFaseSessaoAnterior from './filtros/FiltroMesmaFaseSessaoAnterior';
import FiltroMovimentoDecisaoSessaoAnterior from './filtros/FiltroMovimentoDecisaoSessaoAnterior';
import FiltroNomeRelator from './filtros/FiltroNomeRelator';
import FiltroNumeroProcesso from './filtros/FiltroNumeroProcesso';
import FiltroParteContraria from './filtros/FiltroParteContraria';
import FiltroParteEntePublico from './filtros/FiltroParteEntePublico';
import FiltroParteProcuradoriaPje from './filtros/FiltroParteProcuradoriaPje';
import FiltroPartes from './filtros/FiltroPartes';
import FiltroPeticoesPendentes from './filtros/FiltroPeticoesPendentes';
import FiltroProcessoImportadoSIJ from './filtros/FiltroProcessoImportadoSIJ';
import FiltroProcessosAssociados from './filtros/FiltroProcessosAssociados';
import FiltroRegiaoProcesso from './filtros/FiltroRegiaoProcesso';
import FiltroRepresentantesPartes from './filtros/FiltroRepresentantesPartes';
import FiltroResultadoApreciacaoSessaoAnterior from './filtros/FiltroResultadoApreciacaoSessaoAnterior';
import Filtros from './filtros/Filtros';
import FiltroSegredoJustica from './filtros/FiltroSegredoJustica';
import FiltroSituacaoImpedimentosProcesso from './filtros/FiltroSituacaoImpedimentosProcesso';
import FiltroSituacaoInclusaoPauta from './filtros/FiltroSituacaoInclusaoPauta';
import FiltroSituacaoLiberacaoMinutaVoto from './filtros/FiltroSituacaoLiberacaoMinutaVoto';
import FiltroSituacaoPublicacaoPauta from './filtros/FiltroSituacaoPublicacaoPauta';
import FiltroTipoJulgamento from './filtros/FiltroTipoJulgamento';
import FiltroTipoRemessaJulgamento from './filtros/FiltroTipoRemessaJulgamento';
import FiltroUltimoAndamento from './filtros/FiltroUltimoAndamento';
import FiltroVistor from './filtros/FiltroVistor';

export default class FiltrosPautaJulgamento extends Filtros {
    static ordemFiltroRapido = [
        'filtroPeticoesPendentes',
        'filtroSituacaoInclusaoPauta',
        'filtroCorreJunto',
        'filtroProcessosAssociados',
        'filtroTipoJulgamento',
        'filtroSegredoJustica',
        'filtroTipoRemessaJulgamento',
        'filtroSituacaoLiberacaoMinutaVoto',
        'filtroSituacaoImpedimentosProcesso',
        'filtroInclusaoConfirmadaPauta',
        'filtroSituacaoPublicacaoPauta'
    ];

    ordem = 0;

    filtroAnotacoes = new FiltroAnotacoes({
        idFiltro: 'filtroAnotacoes',
        ordem: this.ordem++,
        store: this.store
    });

    filtroAnotacoesCurtas = new FiltroAnotacoesCurtas({
        idFiltro: 'filtroAnotacoesCurtas',
        ordem: this.ordem++,
        store: this.store
    });

    filtroAnotacoesComplementares = new FiltroAnotacoesComplementares({
        idFiltro: 'filtroAnotacoesComplementares',
        ordem: this.ordem++,
        store: this.store
    });

    filtroNumeroProcesso = new FiltroNumeroProcesso({
        idFiltro: 'filtroNumeroProcesso',
        ordem: this.ordem++,
        store: this.store
    });

    filtroNomeRelator = new FiltroNomeRelator({
        idFiltro: 'filtroNomeRelator',
        ordem: this.ordem++,
        store: this.store
    });

    filtroVistor = new FiltroVistor({
        idFiltro: 'filtroVistor',
        ordem: this.ordem++,
        store: this.store
    });

    filtroClasseJudicial = new FiltroClasseJudicial({
        idFiltro: 'filtroClasseJudicial',
        ordem: this.ordem++,
        store: this.store
    });

    filtroClasseJudicialCompleta = new FiltroClasseJudicialCompleta({
        idFiltro: 'filtroClasseJudicialCompleta',
        ordem: this.ordem++,
        store: this.store
    });

    filtroRegiaoProcesso = new FiltroRegiaoProcesso({
        idFiltro: 'filtroRegiaoProcesso',
        ordem: this.ordem++,
        store: this.store
    });

    filtroSituacaoInclusaoPauta = new FiltroSituacaoInclusaoPauta({
        idFiltro: 'filtroSituacaoInclusaoPauta',
        ordem: this.ordem++,
        store: this.store,
        ordemFiltroRapido: Filtros.posicaoFiltroRapido(
            'filtroSituacaoInclusaoPauta',
            FiltrosPautaJulgamento.ordemFiltroRapido
        )
    });

    filtroPeticoesPendentes = new FiltroPeticoesPendentes({
        idFiltro: 'filtroPeticoesPendentes',
        ordem: this.ordem++,
        store: this.store,
        ordemFiltroRapido: Filtros.posicaoFiltroRapido(
            'filtroPeticoesPendentes',
            FiltrosPautaJulgamento.ordemFiltroRapido
        )
    });

    filtroInclusaoConfirmadaPauta = new FiltroInclusaoConfirmadaPauta({
        idFiltro: 'filtroInclusaoConfirmadaPauta',
        ordem: this.ordem++,
        store: this.store,
        ordemFiltroRapido: Filtros.posicaoFiltroRapido(
            'filtroInclusaoConfirmadaPauta',
            FiltrosPautaJulgamento.ordemFiltroRapido
        )
    });

    filtroSituacaoPublicacaoPauta = new FiltroSituacaoPublicacaoPauta({
        idFiltro: 'filtroSituacaoPublicacaoPauta',
        ordem: this.ordem++,
        store: this.store,
        ordemFiltroRapido: Filtros.posicaoFiltroRapido(
            'filtroSituacaoPublicacaoPauta',
            FiltrosPautaJulgamento.ordemFiltroRapido
        )
    });

    filtroDataPublicacaoPauta = new FiltroDataPublicacaoPauta({
        idFiltro: 'filtroDataPublicacaoPauta',
        ordem: this.ordem++,
        store: this.store
    });

    filtroUltimoAndamento = new FiltroUltimoAndamento({
        idFiltro: 'filtroUltimoAndamento',
        ordem: this.ordem++,
        store: this.store
    });

    filtroResultadoApreciacaoSessaoAnterior = new FiltroResultadoApreciacaoSessaoAnterior({
        idFiltro: 'filtroResultadoApreciacaoSessaoAnterior',
        ordem: this.ordem++,
        store: this.store
    });

    filtroMovimentoDecisaoSessaoAnterior = new FiltroMovimentoDecisaoSessaoAnterior({
        idFiltro: 'filtroMovimentoDecisaoSessaoAnterior',
        ordem: this.ordem++,
        store: this.store
    });

    filtroMesmaFaseSessaoAnterior = new FiltroMesmaFaseSessaoAnterior({
        idFiltro: 'filtroMesmaFaseSessaoAnterior',
        ordem: this.ordem++,
        store: this.store
    });

    filtroPartes = new FiltroPartes({
        idFiltro: 'filtroPartes',
        ordem: this.ordem++,
        store: this.store
    });

    filtroRepresentantesPartes = new FiltroRepresentantesPartes({
        idFiltro: 'filtroRepresentantesPartes',
        ordem: this.ordem++,
        store: this.store
    });

    filtroParteContraria = new FiltroParteContraria({
        idFiltro: 'filtroParteContraria',
        ordem: this.ordem++,
        store: this.store
    });

    filtroParteEntePublico = new FiltroParteEntePublico({
        idFiltro: 'filtroParteEntePublico',
        ordem: this.ordem++,
        store: this.store
    });

    filtroIntimacaoViaMalote = new FiltroIntimacaoViaMalote({
        idFiltro: 'filtroIntimacaoViaMalote',
        ordem: this.ordem++,
        store: this.store
    });

    filtroInformacaoIntimacao = new FiltroInformacaoIntimacao({
        idFiltro: 'filtroInformacaoIntimacao',
        ordem: this.ordem++,
        store: this.store
    });

    filtroSituacaoLiberacaoMinutaVoto = new FiltroSituacaoLiberacaoMinutaVoto({
        idFiltro: 'filtroSituacaoLiberacaoMinutaVoto',
        ordem: this.ordem++,
        store: this.store,
        ordemFiltroRapido: Filtros.posicaoFiltroRapido(
            'filtroSituacaoLiberacaoMinutaVoto',
            FiltrosPautaJulgamento.ordemFiltroRapido
        )
    });

    filtroSegredoJustica = new FiltroSegredoJustica({
        idFiltro: 'filtroSegredoJustica',
        ordem: this.ordem++,
        store: this.store,
        ordemFiltroRapido: Filtros.posicaoFiltroRapido('filtroSegredoJustica', FiltrosPautaJulgamento.ordemFiltroRapido)
    });

    filtroImpedimentos = new FiltroImpedimentos({
        idFiltro: 'filtroImpedimentos',
        ordem: this.ordem++,
        store: this.store
    });

    filtroSituacaoImpedimentosProcesso = new FiltroSituacaoImpedimentosProcesso({
        idFiltro: 'filtroSituacaoImpedimentosProcesso',
        ordem: this.ordem++,
        store: this.store,
        ordemFiltroRapido: Filtros.posicaoFiltroRapido(
            'filtroSituacaoImpedimentosProcesso',
            FiltrosPautaJulgamento.ordemFiltroRapido
        )
    });

    filtroImpedimentosMagistrado = new FiltroImpedimentosMagistrado({
        idFiltro: 'filtroImpedimentosMagistrado',
        ordem: this.ordem++,
        store: this.store
    });

    filtroProcessoImportadoSIJ = new FiltroProcessoImportadoSIJ({
        idFiltro: 'filtroProcessoImportadoSIJ',
        ordem: this.ordem++,
        store: this.store
    });

    filtroIncluidoPeloGabinete = new FiltroIncluidoPeloGabinete({
        idFiltro: 'filtroIncluidoPeloGabinete',
        ordem: this.ordem++,
        store: this.store
    });

    filtroTipoJulgamento = new FiltroTipoJulgamento({
        idFiltro: 'filtroTipoJulgamento',
        ordem: this.ordem++,
        store: this.store,
        ordemFiltroRapido: Filtros.posicaoFiltroRapido('filtroTipoJulgamento', FiltrosPautaJulgamento.ordemFiltroRapido)
    });

    filtroTipoRemessaJulgamento = new FiltroTipoRemessaJulgamento({
        idFiltro: 'filtroTipoRemessaJulgamento',
        ordem: this.ordem++,
        store: this.store,
        ordemFiltroRapido: Filtros.posicaoFiltroRapido(
            'filtroTipoRemessaJulgamento',
            FiltrosPautaJulgamento.ordemFiltroRapido
        )
    });

    filtroParteProcuradoriaPje = new FiltroParteProcuradoriaPje({
        idFiltro: 'filtroParteProcuradoriaPje',
        ordem: this.ordem++,
        store: this.store
    });

    filtroCorreJunto = new FiltroCorreJunto({
        idFiltro: 'filtroCorreJunto',
        ordem: this.ordem++,
        store: this.store,
        ordemFiltroRapido: Filtros.posicaoFiltroRapido('filtroCorreJunto', FiltrosPautaJulgamento.ordemFiltroRapido)
    });

    filtroProcessosAssociados = new FiltroProcessosAssociados({
        idFiltro: 'filtroProcessosAssociados',
        ordem: this.ordem++,
        store: this.store,
        ordemFiltroRapido: Filtros.posicaoFiltroRapido(
            'filtroProcessosAssociados',
            FiltrosPautaJulgamento.ordemFiltroRapido
        )
    });

    filtroIndicadores = new FiltroIndicadores({
        idFiltro: 'filtroIndicadores',
        ordem: this.ordem++,
        store: this.store
    });

    filtroDomicilioEletronico = new FiltroDomicilioEletronico({
        idFiltro: 'filtroDomicilioEletronico',
        ordem: this.ordem++,
        store: this.store
    });

    filtroIntimacaoDomicilioEletronico = new FiltroIntimacaoDomicilioEletronico({
        idFiltro: 'filtroIntimacaoDomicilioEletronico',
        ordem: this.ordem++,
        store: this.store
    });

    filtroCienciaDomicilioEletronico = new FiltroCienciaDomicilioEletronico({
        idFiltro: 'filtroCienciaDomicilioEletronico',
        ordem: this.ordem++,
        store: this.store
    });

    constructor(props) {
        super(props);

        makeObservable(this, {
            ordem: false,
            filtroAnotacoes: observable,
            filtroAnotacoesCurtas: observable,
            filtroAnotacoesComplementares: observable,
            filtroProcessosAssociados: observable,
            filtroMesmaFaseSessaoAnterior: observable,
            filtroNumeroProcesso: observable,
            filtroNomeRelator: observable,
            filtroVistor: observable,
            filtroClasseJudicial: observable,
            filtroClasseJudicialCompleta: observable,
            filtroRegiaoProcesso: observable,
            filtroSituacaoInclusaoPauta: observable,
            filtroPeticoesPendentes: observable,
            filtroInclusaoConfirmadaPauta: observable,
            filtroSituacaoPublicacaoPauta: observable,
            filtroDataPublicacaoPauta: observable,
            filtroUltimoAndamento: observable,
            filtroResultadoApreciacaoSessaoAnterior: observable,
            filtroMovimentoDecisaoSessaoAnterior: observable,
            filtroPartes: observable,
            filtroRepresentantesPartes: observable,
            filtroParteContraria: observable,
            filtroParteEntePublico: observable,
            filtroIntimacaoViaMalote: observable,
            filtroInformacaoIntimacao: observable,
            filtroSituacaoLiberacaoMinutaVoto: observable,
            filtroSegredoJustica: observable,
            filtroImpedimentos: observable,
            filtroSituacaoImpedimentosProcesso: observable,
            filtroImpedimentosMagistrado: observable,
            filtroProcessoImportadoSIJ: observable,
            filtroIncluidoPeloGabinete: observable,
            filtroTipoJulgamento: observable,
            filtroTipoRemessaJulgamento: observable,
            filtroParteProcuradoriaPje: observable,
            filtroCorreJunto: observable,
            filtroIndicadores: observable,
            filtroDomicilioEletronico: observable,
            filtroIntimacaoDomicilioEletronico: observable,
            filtroCienciaDomicilioEletronico: observable
        });
    }
}
